// 프론트 앤드에 띄우는 IEG 에이전트

// const BACKEND_URL = "http://localhost:8000"; // 승호 님의 FastAPI 주소
// API 통합관리
import { BACKEND_URL } from '../config';
/**
 * [핵심] 백엔드(main.py)로 주문서를 날리는 웨이터 함수
 * @param query 사용자 질문 내용
 * @param taskType 업무 종류 (main.py의 PROMPT_TEMPLATES 키와 일치해야 함)
 */
const callIEGAgent = async (query: string, taskType: string = "general") => {
  try {
    const response = await fetch(`${BACKEND_URL}/chat`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ 
        query: query,
        task_type: taskType, // "이건 분석용이야", "이건 문서용이야" 라고 꼬리표 붙임
        session_id: "ieg_user_1"
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.answer; // 백엔드가 준 답변(요리)을 그대로 반환

  } catch (error) {
    console.error("❌ IEG Agent 연결 실패:", error);
    return "죄송합니다. 백엔드 서버(main.py)와 연결이 끊겼습니다. 터미널을 확인해주세요.";
  }
};

// =================================================================
// 👇 각 화면(UI)에서 이 함수들을 불러서 씁니다.
// =================================================================

// 1. 전체 챗봇창 (일반 대화)
export const chatWithCRM = async (message: string) => {
  // taskType을 안 보내면 main.py가 알아서 'general'로 처리함
  return await callIEGAgent(message, "general");
};

// 2. DealBoard (영업 기회 분석)
export const analyzeDealHealth = async (dealTitle: string, contactName: string) => {
  const query = `${contactName} 업체와의 '${dealTitle}' 건에 대한 성공 확률과 전략을 분석해줘.`;
  // 👉 'analysis' 태그를 붙여서 보냄 -> main.py가 "분석가 모드"로 답변함
  return await callIEGAgent(query, "analysis");
};

export const analyzeNewCustomerPotential = async (contact: any) => {
  const query = `${contact.name} 업체의 투자 잠재력과 예상 매출 규모를 추정해줘.`;
  const responseText = await callIEGAgent(query, "analysis");
  
  // (참고) 실제로는 AI가 JSON을 주도록 해야 완벽하지만, 지금은 텍스트를 받아서 가공하거나
  // 일단 화면에 보여주기 위해 임시 객체를 리턴합니다.
  return {
    potential: 'High',
    reason: responseText, // AI의 분석 내용을 여기에 넣음
    estimatedValue: 50000000, 
    suggestedStage: 'Proposal'
  };
};

// 3. SalesSupport (문서 작성 - 제안서/규격서)
export const generateDocDraft = async (type: string, prompt: string, userName: string) => {
  const docType = type === 'specification' ? '규격서' : '제안서';
  const query = `작성자: ${userName}\n문서 종류: ${docType}\n요청 내용: ${prompt}`;
  
  // 👉 'document' 태그를 붙여서 보냄 -> main.py가 "문서 작성 전문가 모드"로 답변함
  return await callIEGAgent(query, "document");
};

// 프롬프트 예시 생성 (이건 서버 안 거치고 그냥 프론트에서 처리해도 됨)
export const generateProposalPrompt = (prompt: string, userName: string) => {
  return `[요청] ${prompt} (작성자: ${userName})`;
};

// 4. Reports (리포트 생성)
export const generateBusinessReport = async (message: string) => {
  // 리액트에서 만든 질문(message)을 그대로 백엔드에 전달
  return await callIEGAgent(message, "report");
};

// 5. 기타 유틸 (이메일 등)
export const generateEmailDraft = async (contact: any, context: string) => {
  const query = `${contact.name} 담당자에게 보낼 이메일 초안. 용건: ${context}`;
  return await callIEGAgent(query, "general"); // 이메일은 일반 모드로 처리
};

export const generateDashboardInsights = async (deals: any, contacts: any) => {
  return await callIEGAgent("현재 대시보드 데이터의 주요 인사이트 3줄 요약", "analysis");
};